export default "__VITE_ASSET__TC6dfeKE__"